import React, { useContext } from 'react';
import {
  AvatarIcon,
  CloseMenuIcon,
} from '@womcorp/wom-miwom-ui-kit/dist/@theme/assets/svg/icons/nav';
import { AnimatePresence } from 'framer-motion';
import { useMediaQuery } from 'react-responsive';
import {
  CloseMenuContainerStyled,
  HeaderContainerStyled,
  HeaderProfileContainerStyled,
  HeaderProfileIconContainerStyled,
  HeaderProfileInfoContainerStyled,
} from './styles/HeaderStyled';
import { AnimationTransitions } from '../SideNavMobile/styles/SideNavMobileStyled';
import useSegment from '../../../hooks/useSegment';
import useUser from '../../../hooks/useUser';
import { Strings } from '../../../helpers';
import AppContext from '../../App/AppContext';

const Header = () => {
  const { showMenuMobile, setShowMenuMobile } = useContext(AppContext);
  const { isPrepaid } = useSegment();
  const user = useUser();

  const isMobileDevice = useMediaQuery({
    query: '(max-device-width: 768px)',
  });

  return isMobileDevice ? (
    <AnimatePresence>
      {showMenuMobile && (
        <HeaderContainerStyled
          variants={AnimationTransitions}
          initial="initial"
          animate="enter"
          exit="exit"
        >
          <HeaderProfileContainerStyled>
            <HeaderProfileIconContainerStyled>
              <AvatarIcon />
            </HeaderProfileIconContainerStyled>
            <HeaderProfileInfoContainerStyled>
              <span>{isPrepaid ? 'Prepago' : user.plan.name}</span>
              <strong>
                {`${Strings.formatHeaderPhoneNumber(user.plan.number)}`}
              </strong>
            </HeaderProfileInfoContainerStyled>
          </HeaderProfileContainerStyled>
          <CloseMenuContainerStyled
            onClick={() => {
              setShowMenuMobile(!showMenuMobile);
            }}
          >
            <CloseMenuIcon />
          </CloseMenuContainerStyled>
        </HeaderContainerStyled>
      )}
    </AnimatePresence>
  ) : (
    <HeaderContainerStyled>
      <HeaderProfileContainerStyled>
        <HeaderProfileIconContainerStyled>
          <AvatarIcon />
        </HeaderProfileIconContainerStyled>
        <HeaderProfileInfoContainerStyled>
          <span>{isPrepaid ? 'Prepago' : user.plan.name}</span>
          <strong>{Strings.formatHeaderPhoneNumber(user.plan.number)}</strong>
        </HeaderProfileInfoContainerStyled>
      </HeaderProfileContainerStyled>
    </HeaderContainerStyled>
  );
};

export default Header;
